app.controller('push_reportController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout) {

	//initialise survey specific views
	pageHandler.initViews(pageConfig, $scope);

	//initialise filters
	var filtersLoaded = pageHandler.initFilters(pageConfig, $scope);
	
	if(filtersLoaded)
	{	
		//initialise components
		pageHandler.initComponents(pageConfig, $scope);
	
		//show loading on components
		pageHandler.showLoading(pageConfig, $scope);

		//request data for components
		pageHandler.requestDataForComponents(pageConfig, $scope);
		
		//initialize export feature
		pageHandler.initPageExports(pageConfig, $scope);
	}
	
	var reportHeading = {};
	reportHeading = {'dealer_name' : $scope.$parent.breadCrumb.filters[1].label, 'date_label': $scope.$parent.breadCrumb.filters[2].label};
	$scope.reportHeading = reportHeading;
});
